<template>
  <DanhSachDonVi @setBreadcrumb="internalSetBreadcrumb"/>
</template>

<script>
import DanhSachDonVi from "@/components/pages/quan-ly-danh-muc/don-vi/DanhSachDonVi.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

export default {
  name: "TrangDanhSachDonVi",
  data() {
    return {
      baseBreadcrumb: `${
        MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.NAME
      }`,
      currentBreadcrumb: `${
        MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.NAME
      }`
    };
  },
  components: {
    DanhSachDonVi
  },
  created() {
    setBreadcrumb(this.currentBreadcrumb);
  },
  methods: {
    internalSetBreadcrumb(isSuaDonVi) {
      if (isSuaDonVi === null) {
        this.currentBreadcrumb = this.baseBreadcrumb;
      } else if (isSuaDonVi === true) {
        this.currentBreadcrumb =
          this.baseBreadcrumb +
          " / " +
          MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.SUA;
      } else {
        this.currentBreadcrumb =
          this.baseBreadcrumb +
          " / " +
          MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.TAO_MOI;
      }
      setBreadcrumb(this.currentBreadcrumb);
    }
  }
};
</script>


